'use client'

import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useSectionViewed } from '@/lib/analytics/use-section-viewed'
import { SiteContainer } from './section'

/**
 * 文末墨底 CTA：置中大標＋lead＋按鈕。全站的節奏轉折點，一頁只有一個。
 *
 * 標題收 `titleKey` 而不是字串，理由同 {@link InkHero}：襯線走 subset 字型，
 * 字集掃描器只認得出原始碼裡的字面 i18n key。
 */

export interface EndCtaProps {
  titleKey: string
  lead?: React.ReactNode
  /** 按鈕列。墨底上的主按鈕是 `onlight`（紙白實心），次要是 `ondark`（描邊）。 */
  actions?: React.ReactNode
  meta?: React.ReactNode
  id?: string
}

export function EndCta({ titleKey, lead, actions, meta, id }: EndCtaProps) {
  const { t } = useTranslation(['web'])
  const viewedRef = useSectionViewed('end_cta')

  return (
    <section
      ref={viewedRef}
      id={id}
      className="bg-foreground py-(--section-space) text-center text-background"
    >
      <SiteContainer>
        <h2
          data-display-font=""
          className="mx-auto max-w-[22em] font-display text-(length:--fs-marketing-h2) leading-[1.22] font-semibold tracking-[0.005em]"
        >
          <Trans t={t} i18nKey={titleKey} />
        </h2>
        {lead ? (
          <p className="mx-auto mt-(--gap-md) text-[length:var(--fs-marketing-lead)] leading-[1.7] text-background/74">
            {lead}
          </p>
        ) : null}
        {actions ? (
          <div className="mt-(--gap-lg) inline-flex flex-wrap items-center justify-center gap-(--gap-sm)">
            {actions}
          </div>
        ) : null}
        {meta ? (
          <p className="mt-(--gap-md) font-mono text-(length:--fs-meta) text-background/62">
            {meta}
          </p>
        ) : null}
      </SiteContainer>
    </section>
  )
}
